module.exports = __webpack_public_path__ + "static/media/swl-logo.b689e1d9.png";